import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import DescriptionIcon from '@material-ui/icons/Description';

const root = createRouteRef();
const page = PageBlueprint.make({
  params: {
    path: '/documentacao',
    title: 'Documentação',
    icon: <DescriptionIcon fontSize="inherit" />,
    noHeader: true,
    routeRef: root,
    loader: async () => {
      const { DocumentationPage } = await import('./DocumentationPage');
      return <DocumentationPage />;
    },
  },
});

export const documentationPlugin = createFrontendPlugin({
  pluginId: 'documentation',
  title: 'Documentação',
  routes: { root },
  extensions: [page],
});
